export class MembershipTokenRedeemError extends Error {
  status?: number;

  constructor(message: string, status?: number) {
    super(message);
    this.name = 'MembershipTokenRedeemError';
    this.status = status;
  }
}

export class MembershipTokenAlreadyOwnedError extends MembershipTokenRedeemError {
  constructor(message = 'Products already owned') {
    super(message, 409);
    this.name = 'MembershipTokenAlreadyOwnedError';
  }
}
